module.exports = __webpack_public_path__ + "img/VN.6133c9f1.png";